import { createFileRoute } from '@tanstack/react-router';

import { requirePermission } from '@/app/guards';
import { analyticsDestinationsQueryOptions, DestinationsPage } from '@/features/analytics';

export const Route = createFileRoute('/_authed/_active/s/$storeId/settings/analytics')({
  staticData: { crumb: 'common:nav.analyticsDestinations', tours: ['settings.analytics'] },
  beforeLoad: ({ context }) => {
    requirePermission(context.me, 'settings.read');
  },
  loader: ({ context, params }) =>
    context.queryClient
      .query({ ...analyticsDestinationsQueryOptions(params.storeId), staleTime: 'static' })
      .catch(() => undefined),
  component: DestinationsPage,
});
